"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AvatarCard_component_exports = {};
__export(AvatarCard_component_exports, {
  AvatarCard: () => AvatarCard
});
module.exports = __toCommonJS(AvatarCard_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_Button = require("../../Button/Button.component");
var import_Link = require("../../Link/Link.component");
var import_SignOut = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/SignOut"));
var import_Helpers = require("../../../utils/Helpers");
var import_RoleSwitchModal = require("../RoleSwitchModal/RoleSwitchModal.component");
const AvatarCard = ({
  firstName = "",
  lastName = "",
  email = "",
  currentRole,
  onLogout,
  availableRoles = [],
  avatarCardRef,
  onSwitchRole
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    "div",
    {
      className: "flex w-[303px] flex-col bg-white shadow-xl md:w-[400px]",
      ref: avatarCardRef,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: "gmui-avatar-card-top-section-container", children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            "div",
            {
              "aria-hidden": "true",
              className: "avatar-popup-button gmui-font-style-body gmui-themed-font-weight-body-medium ml-6 mr-[8px] mt-6 flex items-center justify-center",
              children: (0, import_Helpers.getInitials)(firstName, lastName)
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
            "div",
            {
              className: `flex flex-col ${currentRole === "student" ? "justify-center" : "justify-start"}`,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "mt-6 text-[18px] font-bold", children: `${firstName} ${lastName}` }),
                currentRole !== "student" && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "mt-1 text-sm", children: email }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: "mt-1", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "text-sm", children: "Role: " }),
                    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "text-sm capitalize", children: currentRole })
                  ] }),
                  availableRoles.length > 1 && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                    import_RoleSwitchModal.RoleSwitchModal,
                    {
                      currentRole,
                      availableRoles,
                      onSwitchRole
                    }
                  )
                ] })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "ml-8 mt-6", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Link.Link, { href: "https://digitalsupport.greatminds.org", children: "Help Center" }) }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "mb-4 ml-4 mt-4", children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
            import_Button.Button,
            {
              variant: "tertiary",
              "gmui-theme": "de-brand",
              className: "font-medium",
              onPress: onLogout,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Icon, { "aria-hidden": "true", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_SignOut.default, { title: "Log out", iconSize: "m", color: "#2e3692" }) }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Label, { children: "Log Out" })
              ]
            }
          ) })
        ] })
      ]
    }
  );
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AvatarCard
});
//# sourceMappingURL=AvatarCard.component.js.map